import type { ReactNode } from "react";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./card";

type SectionCardProps = Readonly<{
  /** The anchor the jump links and the readiness list point to. The heading has the id `<id>-title`. */
  id: string;
  title: string;
  description?: ReactNode;
  /** Extra classes for the card (the publish card has an accent border). */
  className?: string;
  children: ReactNode;
}>;

/**
 * A titled card of the catalog pages, built from the kit `Card`. It is a named region: a screen reader finds it by its title. The heading
 * can take focus by code (`tabIndex={-1}`), which is where a jump link moves it.
 */
export function SectionCard({ id, title, description, className, children }: SectionCardProps) {
  return (
    <section id={id} aria-labelledby={`${id}-title`} className="scroll-mt-6">
      <Card className={className}>
        <CardHeader>
          <CardTitle id={`${id}-title`} tabIndex={-1}>
            {title}
          </CardTitle>
          {description ? <CardDescription>{description}</CardDescription> : null}
        </CardHeader>
        <CardContent>{children}</CardContent>
      </Card>
    </section>
  );
}
